import { useEffect, useState } from 'react'

import { config } from 'app/config'

const useWebSocket = (path: string, handleMessage: (message: string) => void) => {
  const [_, setWs] = useState<WebSocket | null>(null)

  const url = `${config.innkeeprBaseWsUrl}/websocket${path}`

  useEffect(() => {
    const socket = new WebSocket(url)
    setWs(socket)

    socket.onopen = () => {
      console.log('Connected to WebSocket on ', url)
    }

    socket.onerror = (event) => console.log('WebSocket error', event)

    socket.onmessage = (event: MessageEvent<string>) => handleMessage(event.data)

    socket.onclose = (ev) => {
      console.log('WebSocket disconnected', ev.reason, ev.code)
    }

    return () => {
      socket.close()
    }
  }, [handleMessage, url])
}

export default useWebSocket
